import Head from 'next/head';
import React, { FC } from 'react';
import type { Breadcrumb, User } from 'src/common/types/api/v4/boats/search';
import ProductAggregateRatingSchema from 'src/common/components/MetaTags/ProductAggregateRatingSchema';
import { LandingResults } from 'src/common/types/api/v4/search/v1/landing';
import BreadcrumbListSchema from 'src/common/components/MetaTags/BreadcrumbSchemaList';
import DescriptionMetaTag from 'src/common/components/MetaTags/DescriptionMetaTag';
import OpenGraphMetaTags from 'src/common/components/MetaTags/OpenGraphMetaTags';
import { SimpleQuestion } from 'src/common/types/common/SimpleQuestion';
import FAQSchema from 'src/common/components/MetaTags/FAQSchema';

export type DlpMetaFieldsProps = {
  content?: LandingResults;
  description?: string;
  breadcrumbs?: Breadcrumb[];
  title?: string;
  faqs?: SimpleQuestion[];
};

const DlpMetaFields: FC<DlpMetaFieldsProps> = ({
  content,
  description,
  breadcrumbs,
  title,
  faqs,
}) => {
  const sampleReviews = content
    ?.reviews
    ?.top_reviews?.map(({ user, public_review, rating }) => ({
      user: user as User,
      public_review,
      rating,
    }));

  return (
    <>
      <Head>
        <title>
          {title}
        </title>
      </Head>
      {description && (
        <DescriptionMetaTag content={description} />
      )}
      { content?.canonical_url && title && (
        <OpenGraphMetaTags
          canonicalPath={content?.canonical_url}
          title={title}
          description={description}
          noIndex={false}
        />
      )}
      {sampleReviews && (
        <ProductAggregateRatingSchema sampleReviews={sampleReviews} />
      )}
      {breadcrumbs && (
        <BreadcrumbListSchema breadcrumbs={breadcrumbs} />
      )}
      {faqs && faqs.length > 0 && <FAQSchema faqs={faqs} />}
    </>
  );
};

export default DlpMetaFields;
